import API from './client'

export interface AccessRequestPayload {
  name:     string
  email:    string
  phone:    string
  company?: string
  role:     'expediteur' | 'livreur' | 'admin'
  volume?:  string
}

export interface AccessRequestItem {
  _id:             string
  name:            string
  email:           string
  phone:           string
  company?:        string
  role:            'expediteur' | 'livreur' | 'admin'
  volume?:         string
  status:          'pending' | 'approved' | 'rejected'
  rejectedReason?: string
  processedBy?:    { _id: string; name: string }
  processedAt?:    string
  createdUserId?:  string
  createdAt:       string
}

export interface AccessRequestsResponse {
  requests:   AccessRequestItem[]
  pagination: { total: number; page: number; limit: number; totalPages: number }
}

export interface AccessRequestStats {
  pending:  number
  approved: number
  rejected: number
  total:    number
}

export const accessRequestsAPI = {
  submit: async (payload: AccessRequestPayload): Promise<void> => {
    await API.post('/access-requests', payload)
  },

  getAll: async (params: {
    page?:   number
    limit?:  number
    status?: string
    role?:   string
    search?: string
  } = {}): Promise<AccessRequestsResponse> => {
    const r = await API.get('/access-requests', { params })
    return r.data
  },

  getStats: async (): Promise<AccessRequestStats> => {
    const r = await API.get('/access-requests/stats')
    return r.data
  },

  approve: async (id: string): Promise<{ success: boolean; userId: string; tempPassword: string }> => {
    const r = await API.patch(`/access-requests/${id}/approve`)
    return r.data
  },

  reject: async (id: string, reason?: string): Promise<void> => {
    await API.patch(`/access-requests/${id}/reject`, { reason })
  },
}
